import { useCallback, useState } from 'react'
import { authService } from '@/services/auth'
import { AuthContext } from './authContext'

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [, setTick] = useState(0)

  const refreshAuth = useCallback(() => {
    setTick(t => t + 1)
  }, [])

  const isAuthenticated = authService.isAuthenticated()

  return (
    <AuthContext.Provider value={{ isAuthenticated, refreshAuth }}>{children}</AuthContext.Provider>
  )
}
